module.exports = __webpack_public_path__ + "img/p1_bg.8fb04972.jpg";